
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class VoucherTaxDetailsGrid extends Serenity.EntityGrid<VoucherTaxDetailsRow, any> {
        protected getColumnsKey() { return 'OMS.VoucherTaxDetails'; }
        protected getDialogType() { return VoucherTaxDetailsDialog; }
        protected getIdProperty() { return VoucherTaxDetailsRow.idProperty; }
        protected getInsertPermission() { return VoucherTaxDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return VoucherTaxDetailsRow.localTextPrefix; }
        protected getService() { return VoucherTaxDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}